<template>
  <div v-if="auctionsCatalog">
    <ArtworkSearch />
    <div class="col">
      <AuctionHouseCard/>
    </div>
    <AuctionHouseTabs class="auctions-catalogs-show-tabs"/>
    <div class="col-12 row no-gutters mt-4 px-0">
      <div class="col-12 col-md-6 filters d-flex flex-column mb-md-5">
        <div class="mb-md-4 pb-md-3 d-flex">
          <div
            v-if="auctionsCatalog.artworksCount"
            v-html="auctionsCatalog.artworksCount + ' obiektów'"
            class="headings--h3 auctions__count m-0 mr-3"
            ></div>
          <div class="d-none d-lg-inline-block switch">
            <div
              @click="isActive = true"
              :class="{ active: isActive }"
              class="grid-view"
              ></div>
            <div
              @click="isActive = false"
              :class="{ active: !isActive }"
              class="list-view ml-2"
              ></div>
          </div>
        </div>
        <div v-if="meta" class="filters__summary align-items-end">
          <span>
            {{ I18n.t('filters.show') }}
            <Filters
              :options="perPage"
              :isShowAllRecordsButtonClicked="isShowAllRecordsButtonClicked"
              @changeSelected="handleSelectChange"
              @allRecordsSelected="toggleIfShowAllRecordsButtonClicked"
              />
          </span>
        </div>
      </div>
      <div class="employee__filtration col-auto col-md-6 d-flex flex-column align-items-end justify-content-end mb-5">
        <Pagination :meta="meta" />
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <div
        v-if="isActive" key="list"
        class="row auctions grid-view"
        >
        <ArtworkRow
          v-for="(artwork, index) in artworks"
          :artwork="artwork"
          :index="index"
          :key="index"
          />
      </div>
      <div
        v-else key="grid"
        class="row auctions"
        >
        <ArtworkRow
          v-for="(artwork, index) in artworks"
          :artwork="artwork"
          :index="index"
          :key="index"
          />
      </div>
    </transition>
    <div class="row employee__filtration no-gutters justify-content-end">
        <Pagination scrollPageToUp :meta="meta" />
    </div>
  </div>
</template>

<script>
  /* global Cookies */
  import { mapActions, mapGetters } from 'vuex';
  import Pagination from '@/shared/components/pagination/index';
  import Filters from '@/shared/components/filters';
  import { FIRST_PAGE, PAGINATION_OPTIONS, DEFAULT_PER_PAGE } from '@/shared/consts';
  import AuctionHouseCard from './auction_house_card';
  import ArtworkSearch from './search';
  import ArtworkRow from './artwork/row';
  import AuctionHouseTabs from './tabs';

  export default {
    name: 'AuctionsCatalog',
    components: {
      ArtworkRow,
      ArtworkSearch,
      AuctionHouseTabs,
      AuctionHouseCard,
      Pagination,
      Filters,
    },
    methods: {
      ...mapActions([
        'getAuctionsCatalog',
        'getArtworks',
        'getCurrentUser',
      ]),
      fetchAuctionsCatalog() {
        this.getAuctionsCatalog();
      },
      fetchArtworks() {
        this.getArtworks(this.params);
      },
      checkView() {
        const view = Cookies.get('viewChoice');
        if (view === 'grid-view') {
          this.isActive = true;
        }
      },
      handleSelectChange(value) {
        this.selectedPerPage = value;
        this.isShowAllRecordsButtonClicked = false;
      },
      toggleIfShowAllRecordsButtonClicked() {
        this.isShowAllRecordsButtonClicked = !this.isShowAllRecordsButtonClicked;
      },
    },
    data() {
      return {
        isActive: false,
        isShowAllRecordsButtonClicked: false,
        perPage: PAGINATION_OPTIONS,
        selectedPerPage: DEFAULT_PER_PAGE,
        params: {
          per_page: this.$route.query.per_page || DEFAULT_PER_PAGE,
          page: this.$route.query.page || FIRST_PAGE,
          search: this.$route.query.q,
        },
      };
    },
    watch: {
      currentPage() {
        if (this.params.page !== this.currentPage.page) {
          this.params.page = this.currentPage.page;
          this.fetchArtworks(this.params);
        }
      },
      selectedPerPage() {
        if (this.params.per_page !== this.selectedPerPage) {
          this.params.per_page = this.selectedPerPage;
          this.$router.push({ name: this.$route.name, query: { page: FIRST_PAGE } });
          this.fetchArtworks(this.params);
        }
      },
      isShowAllRecordsButtonClicked(val) {
        if (val) {
          this.selectedPerPage = this.meta.total_count;
        }
      },
      isActive() {
        if (this.isActive === true) {
          Cookies.set('viewChoice', 'grid-view');
        } else {
          Cookies.set('viewChoice', 'list-view');
        }
      },
    },
    computed: {
      ...mapGetters([
        'auctionsCatalog',
        'artworks',
        'meta',
      ]),
      currentPage() {
        return {
          page: this.$route.query.page || 1,
        };
      },
    },
    created() {
      this.fetchAuctionsCatalog();
      this.fetchArtworks();
      this.checkView();
      this.getCurrentUser();
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/auctions_catalog.vue?63d1b362